import React from 'react'

const OriginErrors = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className="container">
      <div className='row'>
        <div className='col-lg-5 offset-lg-1 col-6 left'>
          <div className='content-wr'>
            {block.left.icon && (
              <img src={block.left.icon} alt={`${block.left.title} - bunny.net`} title={`${block.left.title} - bunny.net`} />
            )}
            {block.left.title && ( <h4 dangerouslySetInnerHTML={{__html: block.left.title}}></h4> )}
            {block.left.text && ( <div className='text-formatted' dangerouslySetInnerHTML={{__html: block.left.text}}></div> )}
          </div>
        </div>
        <div className='col-lg-5 col-6 right'>
          <div className='content-wr top'>
            {block.right_top.icon && (
              <img src={block.right_top.icon} alt={`${block.right_top.title} - bunny.net`} title={`${block.right_top.title} - bunny.net`} />
            )}
            <div className='content'>
              {block.right_top.title && ( <h4 dangerouslySetInnerHTML={{__html: block.right_top.title}}></h4> )}
              {block.right_top.text && ( <div className='text-formatted' dangerouslySetInnerHTML={{__html: block.right_top.text}}></div> )}
            </div>
          </div>
          <div className='content-wr bottom'>
            {block.right_bottom.icon && (
              <img src={block.right_bottom.icon} alt={`${block.right_bottom.title} - bunny.net`} title={`${block.right_bottom.title} - bunny.net`} />
            )}
            <div className='content'>
              {block.right_bottom.title && ( <h4 dangerouslySetInnerHTML={{__html: block.right_bottom.title}}></h4> )}
              {block.right_bottom.text && ( <div className='text-formatted' dangerouslySetInnerHTML={{__html: block.right_bottom.text}}></div> )}
            </div>
          </div>
        </div>
      </div>

      {block.text && ( <div className='text-formatted text-bottom' dangerouslySetInnerHTML={{__html: block.text}}></div> )}
    </div>
  </section>
)

export default OriginErrors
